<div class="list_item">
  <h3>{{shipment.Number}}
    <span style="float: right">{{shipment.CreatedAt | date:'dd.MM.yy'}}</span>
  </h3>
  <p style="margin-top: 0.2em">
    <span>{{shipment | shipmentStatusName}}</span>
  </p>
  <p style="margin-top: 0.2em">
    <span>{{shipment.Receiver.Address}} {{shipment.Receiver.PostCode + ', ' + shipment.Receiver.City}}</span>
  </p>
</div>
